var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',{attrs:{"mode":"out-in"}},[(_vm.condition)?_c('v-skeleton-loader',{attrs:{"type":_vm.type,"types":_vm.customTypes}}):_vm._t("skeleton-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }